const normalizeDate = (dateToNormalize: string) => {
  const date = new Date(dateToNormalize);
  return new Date(date.getTime() - date.getTimezoneOffset() * -60000);
};

export function formatDate(date: string) {
  return new Intl.DateTimeFormat(`en-US`, {
    year: `numeric`,
    month: `short`,
    day: `numeric`,
  }).format(normalizeDate(date));
}

export function formatDateWithTime(date: string) {
  return new Intl.DateTimeFormat(`en-US`, {
    year: `numeric`,
    month: `long`,
    day: `numeric`,
    hour: `numeric`,
    minute: `numeric`,
    hour12: false,
  }).format(normalizeDate(date));
}
